export default __webpack_public_path__ + "static/media/corner-good-karma.3ba98f79.webp";